import messagesForBuilder from "../../utils/messagesForCardBuilder";

const selectAll = 'Select all options that apply';
const amountToBorrow = 'How much do you need?';
const howMuch = 'How much:';
const whenYouNeed = 'When:';
const loanTiming = 'How would you prefer to access these funds?';
const loanTimingOptions = {
  oneTime: 'A one-time lump sum',
  recurring: 'Recurring charges over time',
};
const firstName = 'First Name';
const lastName = 'Last Name';
const email = 'Email';
const phone = 'Phone';
const amount = 'Enter Amount';



export default {

  'guide.name': 'Royal Credit Union | Advisor Guide',
  'guide.context': 'Royal Credit Union Advisor',

  'products.features.title': 'Why is this product for me?',
  'products.disclosures.title': 'Disclosures',

  'nav.prev': 'Back',
  'nav.next': 'Next',

  'landing.title': 'Thank you for choosing Royal Credit Union!',
  'landing.message': 'Please click the “Get Started” button to find the right accounts for your needs.',
  'landing.getStarted': 'Get Started',

  'redirectMessage.path': 'Starting new path...',
  'sidebar.entry.message': 'Welcome',
  'sidebar.checking.message': 'Manage my money with a checking account',
  'sidebar.savings.message': 'Save funds for my goals',
  'sidebar.borrow.message': 'Borrow funds with a loan',
  'sidebar.exit.message': 'Enter your ZIP Code',
  'sidebar.financialWellness.message': 'Financial Wellness',

  'startNewGuide': 'Start New Guide',

  'footer.copyright.lead': 'Copyright ©',
  'footer.copyright.bankName': 'Royal Credit Union',
  'footer.housing': 'Equal Housing Opportunity',
  'footer.privacy': 'Important notice regarding use of cookies: By continuing to use this site, you agree to our use of cookies as described in our <href>https://www.rcu.org/privacy-policy || Privacy Policy</href>.',

  'summary.answers': 'Your Answer List',
  'summary.answersWarning': 'Editing your responses may change your recommendations.',
  'summary.header': 'Your Personalized Product Recommendations',
  'summary.footer': 'The products and services recommended are based on your inputs. By using this tool, you understand that Royal Credit Union is not undertaking to provide impartial investment advice or to give advice in a fiduciary capacity. Further, understand that deposit products offered through this website are NCUA insured, lending products are not NCUA or otherwise federally insured.',
  'summary.actionBar': 'Please text, email or print your recommendations for future reference.',
  'summary.mobile': 'Text',
  'summary.email': 'Email',
  'summary.print': 'Print',
  'summary.schedule': 'Schedule an Appointment',

  'product.add': 'Open Online',
  'product.remove': 'Remove',

  'contactMeForm.header': 'Before You Apply',
  'contactMeForm.contactUsHeader': 'Share Your Result With US',
  'contactMeForm.formInput.firstName': firstName,
  'contactMeForm.formInput.lastName': lastName,
  'contactMeForm.formInput.email': email,
  'contactMeForm.formInput.phone': phone,
  'contactMeForm.openAccount': 'Before you apply, we invite you to share your results with us!  When you provide your name, email, and phone number, we’ll keep track of your recommendation and send you a copy by email. Submit your info to continue to the application.',
  'contactMeForm.contactUs': 'Before you contact us, please share your results with us by submitting the form below. We’ll link your name, email, and phone number to your answers so we can better help you when you get in touch. We’ll also email you a copy of your recommendation. Submit your info to get our contact information.',
  'contactMeForm.contactLoanTeam': 'Before you contact our home loan team, please share your results with us by submitting the form below. We’ll link your name, email, and phone number to your answers so we can better help you when you get in touch. We’ll also email you a copy of your recommendation. Submit your info to get our contact information.',

  'contactMeForm.getStartedHeader': 'Before You Get Started',
  'contactMeForm.getStarted': 'Before you get started, we invite you to share your results with us!  When you provide your name, email, and phone number, we’ll keep track of your recommendation and send you a copy by email. Submit your info to continue.',

  'shareViaEmailComplete.modal.title': 'Success!',
  'shareViaEmailComplete.message': 'A copy of your recommendation has been sent to your email!',

  'success.openAccount.header': 'You\'re all set!',
  'success.openAccount.message': 'We’ll be emailing you a copy of your recommendation soon. You’re ready to begin an application!',
  'success.openAccount.button': 'Begin Application',
  'success.default.header': 'We got it!',
  'success.contactLoanTeam.message': 'We can use this number to look up your information when you call us. If you provided your email address, we’ll also be emailing you your reference number and recommendation results.',
  'success.contactLoanTeam.messageTwo': 'The next step is to contact us! Our home loan team phone number is 715-833-7251. We look forward to hearing from you!',
  'success.contactLoanTeam.button': 'Call 715-833-7251',
  'success.contactUs.message': 'We can use this number to look up your information when you call us. If you provided your email address, we’ll also be emailing you your reference number and recommendation results.',
  'success.contactUs.messageTwo': 'The next step is to contact us! Our Member Service phone number is 800-341-9911. We look forward to hearing from you!',
  'success.contactUs.button': 'Call 800-341-9911',
  'success.educationResources.message': 'We can use this number to look up your information when you call us. If you provided your email address, we’ll also be emailing you your reference number and recommendation results.',
  'success.educationResources.button': 'Get Started',

  'formInput.firstName.placeholder': firstName,
  'formInput.lastName.placeholder': lastName,
  'formInput.email.placeholder': email,
  'formInput.phone.placeholder': phone,
  'formInput.error.required': 'required',
  'formInput.error.validate': 'required',

  'error.question.zipCode': 'Please enter a valid ZIP Code',
  'error.question.postalCode': 'Please enter a valid ZIP Code',

  'uuidMessage': 'We received your info! Your recommendation reference number is: {uuid}. ',

  'cardBuilder__card-content-error': 'Errors found',

  /**
   * ============================
   * ENTRY QUESTIONS
   * ============================
   */

    'reasonForVisit': 'How can Royal help you?',
    'reasonForVisit.subtext': selectAll,
    'reasonForVisit.checking': '<h4>Checking</h4>Manage my money with a checking account',
    'reasonForVisit.checking.icon': '/classpath/assets/images/icons/icon-checking-accounts.svg',
    'reasonForVisit.savings': '<h4>Savings</h4>Save funds for my goals',
    'reasonForVisit.savings.icon': '/classpath/assets/images/icons/icon-savings-category.svg',
    'reasonForVisit.borrow': '<h4>Borrow</h4>Borrow funds with a loan',
    'reasonForVisit.borrow.icon': '/classpath/assets/images/icons/icon-loan.svg',
    'reasonForVisit.all': 'All',

    'isCustomer': 'Are you currently a Member of Royal Credit Union?',
    'isCustomer.true': 'Yes, I am already a Member',
    'isCustomer.false': 'No, not yet, but I am interested in becoming a Member',

    'checkingWithRoyal': 'Do you have a checking account with Royal Credit Union?',
    'checkingWithRoyal.yes': 'Yes',
    'checkingWithRoyal.no': 'No',
    'checkingWithRoyal.dontKnow': 'I don’t know',

    'customerContext': 'Royal has accounts for all ages. Who are you completing this guide for?',
    'customerContext.myself': 'Myself',
    'customerContext.else': 'Someone Else',

    'lifeStage': 'To help us show you the right options, let us know what age group best fits you (or the person the account is for).',
    'lifeStage.tooltip': 'Age requirements may apply when opening certain account types',
    'lifeStage.adult': 'Adult age 26+',
    'lifeStage.youngAdult': 'Adult age 18-25',
    'lifeStage.teen': 'Minor age 13-17',
    'lifeStage.child': 'Minor age 0-12',

    'resourcesInterest': 'Would you be interested in resources to help you reach your financial goals and make informed financial decisions?',
    'resourcesInterest.true': 'Yes',
    'resourcesInterest.false': 'No',

    'resourcesAccess': 'How would you prefer to access resources to help you reach your financial goals and make informed financial decisions?',
    'resourcesAccess.subtext': selectAll,
    'resourcesAccess.online': 'Online on your own',
    'resourcesAccess.inPerson': 'In person at an individual office appointment',

  /**
   * ============================
   * CHECKING QUESTIONS
   * ============================
   */

    'checkingAccountBalanceGroup': 'To recommend the best options for you, let us know how much money you plan to keep in your checking account:',
    'checkingAccountBalance': 'Checking Balance',
    'checkingAccountBalance.input.placeholder': amount,

    'checkingAccountMinimumBalance': 'Are you willing to keep a minimum balance of at least $1,000 in your checking account?',
    'checkingAccountMinimumBalance.true': 'Yes',
    'checkingAccountMinimumBalance.false': 'No',

    'checkingAccountMinimumBalanceHistory': 'Over the last year, has your checking account balance dipped below $1,000?',
    'checkingAccountMinimumBalanceHistory.true': 'Yes',
    'checkingAccountMinimumBalanceHistory.false': 'No',

  /**
   * ============================
   * SAVINGS QUESTIONS
   * ============================
   */

    'savingsGoals': 'Let’s explore your specific savings needs. Which of the following goals apply to you?',
    'savingsGoals.subtext': selectAll,
    'savingsGoals.healthcare': 'Save for healthcare expenses',
    'savingsGoals.futureEvent': 'Save for a future event',
    'savingsGoals.futureEvent.tooltip': 'Vacation/Travel, Holidays, Wedding, Taxes etc.',
    'savingsGoals.retirement': 'Save for retirement',
    'savingsGoals.startOrContinueSaving': 'Start or continue general savings',

    'savingsAccountBalanceGroup': 'To recommend the best options for you, let us know how much money you plan to keep in your savings:',
    'savingsAccountBalance': 'Savings Balance',
    'savingsAccountBalance.input.placeholder': amount,

    'savingsAccountHighInterest': 'Would you like a savings option that offers a higher interest rate and allows flexible access to your funds?',
    'savingsAccountHighInterest.true': 'Yes',
    'savingsAccountHighInterest.false': 'No',

    'currentHealthPlan': 'Are you currently enrolled in a high-deductible health plan (HDHP) or do you have another Health Savings Account qualifier?',
    'currentHealthPlan.employer': 'Yes, through my employer',
    'currentHealthPlan.private': 'Yes, in a non-employer plan or other health coverage',
    'currentHealthPlan.medicare': 'I am enrolled in Medicare',
    'currentHealthPlan.dependent': 'I am claimed as a dependent on someone else’s tax return',
    'currentHealthPlan.none': 'Not currently',

    'savingsFundsAccess': 'How soon will you need access to your savings funds?',
    'savingsFundsAccess.now': 'I always want immediate access to my money',
    'savingsFundsAccess.twoMonths': 'I won’t need the funds for 1 or 2 months',
    'savingsFundsAccess.threeMonths': 'I won’t need the funds for 3 months or more',

    'savingsMultipleDeposits': 'Are you planning to make multiple deposits into your savings?',
    'savingsMultipleDeposits.true': 'Yes, multiple deposits',
    'savingsMultipleDeposits.false': 'Not more than once',

  /**
   * ============================
   * BORROWING QUESTIONS
   * ============================
   */

    'borrowGoalsQuestionGroup': "Let’s look at your borrowing needs. Which of these goals apply?",
    'borrowGoalsQuestionGroup.subtext': selectAll,
    'borrowGoalTypes.cardBuilder.removeCard': 'Remove',
    'borrowGoalTypes.cardBuilder.editCard': 'Edit',
    'borrowGoalTypes.cardBuilder.addCard': 'Add Goal',
    'borrowGoalTypes.cardBuilder.saveCard': 'Save',
    'borrowGoalTypes.cardBuilder.modal.title': 'Select a goal from the options below.',
    'borrowGoalTypes': 'Your Goals:',

    'homeGoal.cardBuilder.title': 'Purchase or refinance a home or other property',
    'borrowGoalTypes.homeGoal': 'Purchase or refinance a home or other property',
    'borrowGoalTypes.homeGoal.label': 'Purchase or refinance a home or other property',
    'borrowGoalTypes.homeGoal.icon': '/classpath/assets/images/icons/icon-buy-home.svg',
    'homeGoalTransaction': 'Which of the following apply?',
    'homeGoalTransaction.purchase': 'Purchase a home or property',
    'homeGoalTransaction.refinance': 'Refinance a home or property',

    'homeImprovementGoal.cardBuilder.title': 'Make home improvements',
    'borrowGoalTypes.homeImprovementGoal': 'Make home improvements',
    'borrowGoalTypes.homeImprovementGoal.label': 'Make home improvements',
    'borrowGoalTypes.homeImprovementGoal.icon': '/classpath/assets/images/icons/icon-home-improvement.svg',
    'homeImprovementGoalAmount': amountToBorrow,
    'homeImprovementGoalAmount.input.placeholder': '$0',
    'homeImprovementGoalAmount.cardBuilder.answerLabel': howMuch,
    'details.homeImprovementGoalAmount': `Goals: Make home improvements | ${amountToBorrow}`,
    'homeImprovementGoalTiming': loanTiming,
    'homeImprovementGoalTiming.oneTime': loanTimingOptions.oneTime,
    'homeImprovementGoalTiming.recurring': loanTimingOptions.recurring,
    'homeImprovementGoalTiming.cardBuilder.answerLabel': whenYouNeed,
    'details.homeImprovementGoalTiming': `Goals: Make home improvements | ${loanTiming}`,

    'vehicleGoal.cardBuilder.title': 'Auto Loan: purchase or refinance a vehicle',
    'borrowGoalTypes.vehicleGoal': 'Auto Loan: purchase or refinance a vehicle',
    'borrowGoalTypes.vehicleGoal.label': 'Auto Loan: purchase or refinance a vehicle',
    'borrowGoalTypes.vehicleGoal.icon': '/classpath/assets/images/icons/icon-buy-car.svg',
    'vehicleGoalSelection': 'Selected',
    'vehicleGoalDetails': 'No additional details required.',

    'recreationalGoal.cardBuilder.title': 'Recreational loan: purchase or refinance non-auto vehicles',
    'borrowGoalTypes.recreationalGoal': 'Recreational loan: purchase or refinance non-auto vehicles',
    'borrowGoalTypes.recreationalGoal.label': 'Recreational loan: purchase or refinance non-auto vehicles',
    'borrowGoalTypes.recreationalGoal.icon': '/classpath/assets/images/icons/icon-rec-loan.svg',
    'borrowGoalTypes.recreationalGoal.tooltip': 'tooltip',
    'recreationalGoalSelection': 'Selected',
    'recreationalGoalDetails': 'No additional details required.',
    'recreationalGoalDetails.tooltip': 'Recreational loans are available for: Boats, Recreational vehicles (RVs), Motor homes, Campers, Hauling or travel trailers, Motorcycles, ATVs, Dirt bikes, Farm machinery, Garden tractors, Jet skis or personal watercraft, Snowmobiles',

    'studentGoal.cardBuilder.title': 'Student loan: new or consolidation of education loans',
    'borrowGoalTypes.studentGoal': 'Student loan: new or consolidation of education loans',
    'borrowGoalTypes.studentGoal.label': 'Student loan: new or consolidation of education loans',
    'borrowGoalTypes.studentGoal.icon': '/classpath/assets/images/icons/icon-student-loan.svg',
    'studentGoalSelection': 'Selected',
    'studentGoalDetails': 'No additional details required.',

    'debtConsolidationGoal.cardBuilder.title': 'Debt Consolidation',
    'borrowGoalTypes.debtConsolidationGoal': 'Debt Consolidation',
    'borrowGoalTypes.debtConsolidationGoal.label': 'Debt Consolidation',
    'borrowGoalTypes.debtConsolidationGoal.icon': '/classpath/assets/images/icons/icon-debt-consolidation-1.svg',
    'debtConsolidationGoalAmount': "How much debt would you like to consolidate?",
    'debtConsolidationGoalAmount.input.placeholder': amount,
    'debtConsolidationGoalAmount.tooltip': "This type of loan includes: credit cards and other loan debt",
    'debtConsolidationGoalAmount.cardBuilder.answerLabel': howMuch,
    'details.debtConsolidationGoalAmount': `Goals: Debt Consolidation | ${amountToBorrow}`,

    'otherGoal.cardBuilder.title': 'Other Lending Needs',
    'borrowGoalTypes.otherGoal': 'Other Lending Needs',
    'borrowGoalTypes.otherGoal.label': 'Other Lending Needs',
    'borrowGoalTypes.otherGoal.icon': '/classpath/assets/images/icons/icon-other-lending.svg',
    'otherGoalAmount': amountToBorrow,
    'otherGoalAmount.input.placeholder': amount,
    'otherGoalAmount.tooltip': "This type of loan includes: Future Event, Vacation/Travel, Holidays, Wedding, Build/Establish credit etc.",
    'otherGoalAmount.cardBuilder.answerLabel': howMuch,
    'details.otherGoalAmount': `Goals: Other Lending Needs | ${amountToBorrow}`,
    'otherGoalTiming': loanTiming,
    'otherGoalTiming.oneTime': loanTimingOptions.oneTime,
    'otherGoalTiming.recurring': loanTimingOptions.recurring,
    'otherGoalTiming.cardBuilder.answerLabel': whenYouNeed,
    'details.otherGoalTiming': `Goals: Other Lending Needs | ${loanTiming}`,

    'creditCardGoal.cardBuilder.title': 'Opening a Credit Card',
    'borrowGoalTypes.creditCardGoal': 'Opening a Credit Card',
    'borrowGoalTypes.creditCardGoal.label': 'Opening a Credit Card',
    'borrowGoalTypes.creditCardGoal.icon': '/classpath/assets/images/icons/icon-credit-card.svg',
    'creditCardGoalSelection': 'Selected',
    'creditCardGoalDetails': 'No additional details required.',

    'homeOwnerStatus': 'Which of the following options best describes your home purchase?',
    'homeOwnerStatus.newHome': 'Buying a home',
    'homeOwnerStatus.newConstruction': 'New construction or vacant land',
    'homeOwnerStatus.investment': 'Investment property',

    'useHomeEquity': 'If you have a home or vehicle that is worth more than you owe on it, you may have equity to use toward a loan. If you have equity available, would you like to use it?',
    'useHomeEquity.home': 'Yes, I would like to use the equity in my home',
    'useHomeEquity.vehicle': 'Yes, I would like to use the equity in my vehicle',
    'useHomeEquity.none': 'No, I do not want to use equity or I don’t have equity available',

    'homeValueGroup': 'What is the estimated value of your home?',
    'homeValue': 'Home Value',
    'homeValue.input.placeholder': amount,

    'mortgageBalanceGroup': 'How much do you still owe on your home? Enter 0 if your home is paid off.',
    'mortgageBalance': 'Mortgage Balance',
    'mortgageBalance.input.placeholder': amount,

    'postalCodeGroup': 'Where do you live?',
    'postalCode': 'ZIP Code',
    'postalCode.subtext': 'Enter your ZIP Code to see the accounts that are right for you',
    'postalCode.input.placeholder': 'Enter your ZIP Code',

  /**
   * ============================
   * All ROYAL  PRODUCTS
   * ============================
   */

    // TODO: product.actionType.identifier = define the standard for the number
    // TODO: define open, member, non-member, apply and contact - the type dictates which message to grab and then throw in to the CTA
    // 1: Open Account
    // 2: Member Open Account
    // 3: Non Member Open Account
    // 4: Apply now
    // 5: Contact Royal

    /* FAKE PRODUCT FOR NO MATCHES */
    '0000.name': 'Contact Us',
    '0000.icon': '/classpath/assets/images/icons/icon-contact.svg',
    '0000.description': `Royal is here to help! Visit any office, email <href>mailto: member_services@rcu.org || member_services@rcu.org</href>, or call 800-341-9911 for more help finding the right option for you.`,
    '0000.url': 'https://www.rcu.org/contact',
    '0000.actionType': '1',
    '0000.actionType.url': 'https://www.rcu.org/contact',
    '0000.actionType.buttonText': 'Contact Royal',

    '3000.name': 'Personal Savings',
    '3000.icon': '/classpath/assets/images/icons/icon-start-continue-save.svg',
    '3000.description': 'You\'ll need a savings account with at least $5 to be a Royal Member.',
    '3000.features.count': 2,
    '3000.features.1': 'A personal savings account is required to be a Member of Royal Credit Union',
    '3000.features.2': 'Free ATM withdrawals at 40,000+ ATMs nationwide',
    '3000.url': 'https://www.rcu.org/checking-savings/savings-accounts/personal-savings',
    '3000.actionType': '1',
    '3000.actionType.url': 'https://app.consumer.meridianlink.com/xa/xpressApp.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSMHgSJcNLeGXLfdNSEtvS6wDKqSFS4eX1RSvHIGiqUeY',
    '3000.actionType.buttonText': 'Open Account',
    '3000.disclosures.count': 0,

    '3001.name': 'Minor Savings',
    '3001.icon': '/classpath/assets/images/icons/icon-kids-savings.svg',
    '3001.description': 'You\'ll need a savings account with at least $5 to be a Royal Member. Kids ages 12 and under will be enrolled in our Kid’s Club program with fun perks!',
    '3001.features.count': 2,
    '3001.features.1': 'A personal savings account is required to be a Member of Royal Credit Union',
    '3001.features.2': 'A parent or legal guardian must be a joint owner on all minor accounts',
    '3001.url': 'https://www.rcu.org/checking-savings/savings-accounts/kids-savings',
    '3001.actionType': '1',
    '3001.actionType.url': 'https://app.consumer.meridianlink.com/apply.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSn8o3dzOzOzEoJu1M9g82m08U7i6BCHxpn9b3nRLaM6Q',
    '3001.actionType.buttonText': 'Open Account',
    '3001.disclosures.count': 0,

    '3002.name': 'Smart Start Checking',
    '3002.icon': '/classpath/assets/images/icons/smart-start-checking-icon.svg',
    '3002.description': 'No-minimum checking with extra perks just for ages 13-25.',
    '3002.features.count': 6,
    '3002.features.1': 'Two free NSF refunds per year',
    '3002.features.2': 'Way-to-Go Rewards for on-time auto or home loan payments',
    '3002.features.3': 'Free Visa® debit card with secure EMV chip',
    '3002.features.4': '40 free checks for new accounts',
    '3002.features.5': 'Free electronic or paper statements',
    '3002.features.6': 'Free unlimited check writing',
    '3002.url': 'https://www.rcu.org/checking-savings/checking-accounts/smart-start-checking',
    '3002.actionType': '2',
    '3002.actionType.member': 'https://app.consumer.meridianlink.com/xa/xpressApp.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSMHgSJcNLeGXLfdNSEtvS6wyW3KPxZ5_asv5lOOwZWOE',
    '3002.actionType.nonMember': 'https://app.consumer.meridianlink.com/xa/xpressApp.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSMHgSJcNLeGXLfdNSEtvS6wDKqSFS4eX1RSvHIGiqUeY',
    '3002.actionType.buttonText': 'Open Account',
    '3002.disclosures.count': 0,

    '3003.name': 'Minor Smart Start Checking',
    '3003.icon': '/classpath/assets/images/icons/smart-start-checking-icon.svg',
    '3003.description': 'No-minimum checking with extra perks just for ages 13-25.',
    '3003.features.count': 7,
    '3003.features.1': 'Two free NSF refunds per year',
    '3003.features.2': 'Way-to-Go Rewards for on-time auto or home loan payments',
    '3003.features.3': 'Free Visa® debit card with secure EMV chip',
    '3003.features.4': '40 free checks for new accounts',
    '3003.features.5': 'Free electronic or paper statements',
    '3003.features.6': 'Free unlimited check writing',
    '3003.features.7': 'A parent or legal guardian must be a joint owner on all minor accounts.',
    '3003.url': 'https://www.rcu.org/checking-savings/checking-accounts/smart-start-checking',
    '3003.actionType': '2',
    '3003.actionType.member': 'https://app.consumer.meridianlink.com/apply.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSn8o3dzOzOzEoJu1M9g82m4T_I9H1WFbOsxXSVHaU5-w',
    '3003.actionType.nonMember': 'https://app.consumer.meridianlink.com/apply.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSn8o3dzOzOzEoJu1M9g82m08U7i6BCHxpn9b3nRLaM6Q',
    '3003.actionType.buttonText': 'Open Account',
    '3003.disclosures.count': 0,

    '3004.name': 'Smart Checking',
    '3004.icon': '/classpath/assets/images/icons/smart-checking-icon.svg',
    '3004.description': 'No-minimum checking with all the features you need.',
    '3004.features.count': 5,
    '3004.features.1': 'Free Visa® debit card with secure EMV chip',
    '3004.features.2': '40 free checks for new accounts',
    '3004.features.3': 'Free electronic or paper statements',
    '3004.features.4': 'Free unlimited check writing',
    '3004.features.5': 'Real-time account alerts',
    '3004.url': 'https://www.rcu.org/checking-savings/checking-accounts/smart-checking',
    '3004.actionType': '2',
    '3004.actionType.member': 'https://app.consumer.meridianlink.com/xa/xpressApp.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSMHgSJcNLeGXLfdNSEtvS6wyW3KPxZ5_asv5lOOwZWOE',
    '3004.actionType.nonMember': 'https://app.consumer.meridianlink.com/xa/xpressApp.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSMHgSJcNLeGXLfdNSEtvS6wDKqSFS4eX1RSvHIGiqUeY',
    '3004.actionType.buttonText': 'Open Account',
    '3004.disclosures.count': 0,

    '3005.name': 'Minor Smart Checking',
    '3005.icon': '/classpath/assets/images/icons/icon-checking-accounts.svg',
    '3005.description': 'No-minimum checking with all the features you need.',
    '3005.features.count': 6,
    '3005.features.1': 'Free Visa® debit card with secure EMV chip',
    '3005.features.2': '40 free checks for new accounts',
    '3005.features.3': 'Free electronic or paper statements',
    '3005.features.4': 'Free unlimited check writing',
    '3005.features.5': 'Real-time account alerts',
    '3005.features.6': 'A parent or legal guardian must be a joint owner on all minor accounts. ',
    '3005.url': 'https://www.rcu.org/checking-savings/checking-accounts/smart-checking',
    '3005.actionType': '2',
    '3005.actionType.member': 'https://app.loanspq.com/apply.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSn8o3dzOzOzEoJu1M9g82m4T_I9H1WFbOsxXSVHaU5-w',
    '3005.actionType.nonMember': 'https://app.loanspq.com/apply.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSn8o3dzOzOzEoJu1M9g82m08U7i6BCHxpn9b3nRLaM6Q',
    '3005.actionType.buttonText': 'Open Account',
    '3005.disclosures.count': 0,

    '3006.name': 'Smart Checking Plus',
    '3006.icon':'/classpath/assets/images/icons/smart-checking-plus-icon.svg',
    '3006.description': 'Keep your balance above $700 for the entire month to earn dividends and avoid a $10 monthly charge.',
    '3006.features.count': 5,
    '3006.features.1': 'Free Visa® debit card with secure EMV chip',
    '3006.features.2': '40 free checks for new accounts',
    '3006.features.3': 'Free electronic or paper statements',
    '3006.features.4': 'Free unlimited check writing',
    '3006.features.5': 'Real-time account alerts',
    '3006.url': 'https://www.rcu.org/checking-savings/checking-accounts/smart-checking',
    '3006.actionType': '2',
    '3006.actionType.member': 'https://app.consumer.meridianlink.com/xa/xpressApp.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSMHgSJcNLeGXLfdNSEtvS6wyW3KPxZ5_asv5lOOwZWOE',
    '3006.actionType.nonMember': 'https://app.consumer.meridianlink.com/xa/xpressApp.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSMHgSJcNLeGXLfdNSEtvS6wDKqSFS4eX1RSvHIGiqUeY',
    '3006.actionType.buttonText': 'Open Account',
    '3006.disclosures.count': 0,

    '3007.name': 'Kwik Cash Overdraft Protection',
    '3007.icon': '/classpath/assets/images/icons/overdraft-protection_1.svg',
    '3007.description': 'Line of credit used to prevent overdrafts or in case of emergencies.',
    '3007.features.count': 2,
    '3007.features.1': 'Can automatically advance funds to cover overdrafts',
    '3007.features.2': 'Easy access to emergency funds when you need them ',
    '3007.url': 'https://www.rcu.org/loans-credit/credit/overdraft-protection',
    '3007.actionType': '3',
    '3007.actionType.url': 'https://www.loanliner.com/LoanRequest/CLPPresenter/GettingStarted.aspx?CUID=04809906&LoanFormId=8929960810005124958&ChannelId=3987423704049170222&LocationId=6138423703014152319&IsFramed=F',
    '3007.actionType.buttonText': 'Apply Now',
    '3007.disclosures.count': 0,

    '3008.name': 'Personal Savings',
    '3008.icon': '/classpath/assets/images/icons/icon-start-continue-save.svg',
    '3008.description': 'Secondary Savings accounts are additional savings accounts which can be used for anything. Examples including saving for Christmas, vacations, or weddings.',
    '3008.features.count': 1,
    '3008.features.1': 'Free ATM withdrawals at 40,000+ ATMs nationwide',
    '3008.url': 'https://www.rcu.org/checking-savings/savings-accounts/personal-savings ',
    '3008.actionType': '1',
    '3008.actionType.url': 'https://app.consumer.meridianlink.com/xa/xpressApp.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSMHgSJcNLeGXLfdNSEtvS6wyW3KPxZ5_asv5lOOwZWOE',
    '3008.actionType.buttonText': 'Open Account',
    '3008.disclosures.count': 0,

    '3009.name': 'Minor Savings',
    '3009.icon': '/classpath/assets/images/icons/icon-kids-savings.svg',
    '3009.description': 'Secondary Savings accounts are additional savings accounts which can be used for anything. Kids ages 12 and under will be enrolled in our Kid’s Club program with fun perks!',
    '3009.features.count': 1,
    '3009.features.1': 'A parent or legal guardian must be a joint owner on all minor accounts.',
    '3009.url': 'https://www.rcu.org/checking-savings/savings-accounts/kids-savings',
    '3009.actionType': '1',
    '3009.actionType.url': 'https://app.consumer.meridianlink.com/apply.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSn8o3dzOzOzEoJu1M9g82m4T_I9H1WFbOsxXSVHaU5-w',
    '3009.actionType.buttonText': 'Open Account',
    '3009.disclosures.count': 0,

    '3010.name': 'HSA',
    '3010.icon': '/classpath/assets/images/icons/hsa-icon.svg',
    '3010.description': 'A special account used for medical expenses. A high deductible health plan is required and other limitations apply.',
    '3010.features.count': 3,
    '3010.features.1': 'Tax-sheltered savings for qualified medical expenses',
    '3010.features.2': 'Includes a debit card',
    '3010.features.3': 'Requires a high deductible health plan',
    '3010.url': 'https://www.rcu.org/checking-savings/savings-accounts/health-savings-account',
    '3010.actionType': '2',
    '3010.actionType.member': 'https://app.consumer.meridianlink.com/xa/xpressApp.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSMHgSJcNLeGXLfdNSEtvS6wyW3KPxZ5_asv5lOOwZWOE',
    '3010.actionType.nonMember': 'https://app.consumer.meridianlink.com/xa/xpressApp.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSMHgSJcNLeGXLfdNSEtvS6wDKqSFS4eX1RSvHIGiqUeY',
    '3010.actionType.buttonText': 'Open Account',
    '3010.disclosures.count': 0,

    '3011.name': 'Money Market',
    '3011.icon': '/classpath/assets/images/icons/money-market-icon.svg',
    '3011.description': 'Earn higher dividends on higher balances while being able to access funds anytime.',
    '3011.features.count': 4,
    '3011.features.1': 'Access your funds anytime',
    '3011.features.2': 'Tiered dividend means higher balances earn higher returns ',
    '3011.features.3': 'No minimum balance',
    '3011.features.4': 'No deposit or withdrawal minimum',
    '3011.url': 'https://www.rcu.org/checking-savings/checking-accounts/money-market',
    '3011.actionType': '2',
    '3011.actionType.member': 'https://app.consumer.meridianlink.com/xa/xpressApp.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSMHgSJcNLeGXLfdNSEtvS6wyW3KPxZ5_asv5lOOwZWOE',
    '3011.actionType.nonMember': 'https://app.consumer.meridianlink.com/xa/xpressApp.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSMHgSJcNLeGXLfdNSEtvS6wDKqSFS4eX1RSvHIGiqUeY',
    '3011.actionType.buttonText': 'Open Account',
    '3011.disclosures.count': 0,

    '3012.name': 'Certificate',
    '3012.icon': '/classpath/assets/images/icons/share-certificates-icon.svg',
    '3012.description': 'Leave your money in an account for a set time and earn higher dividends.',
    '3012.features.count': 2,
    '3012.features.1': 'Earns dividends based on length of term',
    '3012.features.2': 'No minimum balance to open',
    '3012.url': 'https://www.rcu.org/investments-retirement-accounts/certificates',
    '3012.actionType': '2',
    '3012.actionType.member': 'https://app.consumer.meridianlink.com/xa/xpressApp.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSMHgSJcNLeGXLfdNSEtvS6wyW3KPxZ5_asv5lOOwZWOE',
    '3012.actionType.nonMember': 'https://app.consumer.meridianlink.com/xa/xpressApp.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSMHgSJcNLeGXLfdNSEtvS6wDKqSFS4eX1RSvHIGiqUeY',
    '3012.actionType.buttonText': 'Open Account',
    '3012.disclosures.count': 0,

    '3013.name': 'Minor Certificate',
    '3013.icon': '/classpath/assets/images/icons/share-certificates-icon.svg',
    '3013.description': 'Leave your money in an account for a set time and earn higher dividends.',
    '3013.features.count': 3,
    '3013.features.1': 'Earns dividends based on length of term',
    '3013.features.2': 'No minimum balance to open',
    '3013.features.3': 'A parent or legal guardian must be a joint owner on all minor accounts',
    '3013.url': 'https://www.rcu.org/investments-retirement-accounts/certificates',
    '3013.actionType': '2',
    '3013.actionType.member': 'https://app.consumer.meridianlink.com/apply.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSn8o3dzOzOzEoJu1M9g82m4T_I9H1WFbOsxXSVHaU5-w',
    '3013.actionType.nonMember': 'https://app.consumer.meridianlink.com/apply.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSn8o3dzOzOzEoJu1M9g82m08U7i6BCHxpn9b3nRLaM6Q',
    '3013.actionType.buttonText': 'Open Account',
    '3013.disclosures.count': 0,

    '3014.name': 'Traditional IRA',
    '3014.icon': '/classpath/assets/images/icons/icon-retirement.svg',
    '3014.description': 'Contributions are made with pre-tax dollars (and are tax deductible), but retirement withdrawals are taxed. There is a required minimum distribution and early withdrawal penalty.',
    '3014.features.count': 2,
    '3014.features.1': 'Choose fixed or variable rate IRA certificates, or IRA savings',
    '3014.features.2': 'Contributions can be used to lower your taxable income',
    '3014.url': 'https://www.rcu.org/investments-retirement-accounts/ira',
    '3014.actionType': '2',
    '3014.actionType.member': 'https://app.consumer.meridianlink.com/xa/xpressApp.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSMHgSJcNLeGXLfdNSEtvS6wyW3KPxZ5_asv5lOOwZWOE',
    '3014.actionType.nonMember': 'https://app.consumer.meridianlink.com/xa/xpressApp.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSMHgSJcNLeGXLfdNSEtvS6wDKqSFS4eX1RSvHIGiqUeY',
    '3014.actionType.buttonText': 'Open Account',
    '3014.disclosures.count': 0,

    '3015.name': 'Roth IRA',
    '3015.icon': '/classpath/assets/images/icons/icon-retirement.svg',
    '3015.description': 'Contributions are made with after-tax dollars (meaning they are taxable), but withdrawals are not taxed. No required distributions, but income limits apply.',
    '3015.features.count': 4,
    '3015.features.1': 'Choose fixed or variable rate IRA certificates, or IRA savings',
    '3015.features.2': 'You can withdraw contributions and earnings without taxes or penalties at age 59-1/2',
    '3015.features.3': 'Contributions (but not earnings) may be withdrawn at any time without taxes or penalties',
    '3015.features.4': 'Income limits apply as defined by the IRS',
    '3015.url': 'https://www.rcu.org/investments-retirement-accounts/ira',
    '3015.actionType': '2',
    '3015.actionType.member': 'https://app.consumer.meridianlink.com/xa/xpressApp.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSMHgSJcNLeGXLfdNSEtvS6wyW3KPxZ5_asv5lOOwZWOE',
    '3015.actionType.nonMember': 'https://app.consumer.meridianlink.com/xa/xpressApp.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSMHgSJcNLeGXLfdNSEtvS6wDKqSFS4eX1RSvHIGiqUeY',
    '3015.actionType.buttonText': 'Open Account',
    '3015.disclosures.count': 0,

    '3016.name': 'Financial Advisor',
    '3016.icon': '/classpath/assets/images/buy-a-car-icon.svg',
    '3016.description': '',
    '3016.features.count': 0,
    '3016.url': 'https://www.rcu.org/investments-retirement-accounts/ira',
    '3016.disclosures.count': 0,

    '3017.name': 'Auto Loan',
    '3017.icon': '/classpath/assets/images/icons/icon-buy-car.svg',
    '3017.description': 'Car or truck loans for new or used autos with low rates and a variety of terms.',
    '3017.features.count': 3,
    '3017.features.1': 'Finance new or used cars or trucks',
    '3017.features.2': 'Various terms and rates available',
    '3017.features.3': 'Same-day approval for most auto loans',
    '3017.url': 'https://www.rcu.org/loans-credit/loans/auto-loan',
    '3017.actionType': '3',
    '3017.actionType.url': 'https://www.loanliner.com/LoanRequest/Presenter/LoanList/04809906/1129?isframed=F&cuid=04809906&loanlistid=1129&channelid=NONE&locationid=NONE',
    '3017.actionType.buttonText': 'Apply Now',
    '3017.disclosures.count': 0,

    '3018.name': 'Recreational Loan',
    '3018.icon': '/classpath/assets/images/icons/icon-rec-loan.svg',
    '3018.description': 'Loans for motorcycles, UTVs, boats, snowmobiles, RVs, and many other non-auto vehicles and collateral.',
    '3018.features.count': 2,
    '3018.features.1': 'Finance almost any type of recreational vehicle or collateral',
    '3018.features.2': 'Various terms and rates available',
    '3018.url': 'https://www.rcu.org/loans-credit/loans/recreational-loans',
    '3018.actionType': '3',
    '3018.actionType.url': 'https://www.loanliner.com/LoanRequest/Presenter/LoanList/04809906/751?isframed=F&cuid=04809906&loanlistid=751&channelid=NONE&locationid=NONE',
    '3018.actionType.buttonText': 'Apply Now',
    '3018.disclosures.count': 0,

    '3019.name': 'Student Loan',
    '3019.icon': '/classpath/assets/images/icons/icon-student-loan.svg',
    '3019.description': 'Supplements federal student loan funds for college students or consolidates existing student loans. Amount limits may apply.',
    '3019.features.count': 3,
    '3019.features.1': 'Supplements federal student loan funds',
    '3019.features.2': 'Requires enrollment at qualifying educational institution',
    '3019.features.3': 'Can also be used to consolidate existing student loans',
    '3019.url': 'https://www.rcu.org/loans-credit/loans/student-loan',
    '3019.actionType': '3',
    '3019.actionType.url': 'https://apps.curevl.com/onlineapp/royalpsl.aspx',
    '3019.actionType.buttonText': 'Apply Now',
    '3019.disclosures.count': 0,

    '3020.name': 'Secured Personal Loan',
    '3020.icon': '/classpath/assets/images/icons/other-lending-icon.svg',
    '3020.description': 'This type of loan is secured by something you own, called collateral, and offers a set term and low fixed rate.',
    '3020.features.count': 2,
    '3020.features.1': 'Because the loan is backed by your collateral, the rate is often lower than an unsecured loan',
    '3020.features.2': 'Various terms available',
    '3020.url': 'https://www.rcu.org/loans-credit/loans/personal-loans',
    '3020.actionType': '3',
    '3020.actionType.url': 'https://www.cmg.loanliner.com/loanrequest/presenter/LoanList/04809906/750?isframed=F&cuid=04809906&loanlistid=750&channelid=NONE&locationid=NONE',
    '3020.actionType.buttonText': 'Apply Now',
    '3020.disclosures.count': 0,

    '3021.name': 'Unsecured Personal Loan',
    '3021.icon': '/classpath/assets/images/icons/other-lending-icon.svg',
    '3021.description': 'No collateral is required for this type of loan, only your signature. Choose from set terms and get a low fixed rate.',
    '3021.features.count': 2,
    '3021.features.1': 'You don’t need to put up any collateral to back an unsecured personal loan',
    '3021.features.2': 'Various terms available',
    '3021.url': 'https://www.rcu.org/loans-credit/loans/personal-loans',
    '3021.actionType': '3',
    '3021.actionType.url': 'https://www.cmg.loanliner.com/loanrequest/presenter/LoanList/04809906/1130?isframed=F&cuid=04809906&loanlistid=1130&channelid=NONE&locationid=NONE',
    '3021.actionType.buttonText': 'Apply Now',
    '3021.disclosures.count': 0,

    '3022.name': 'Platinum Rewards Visa® Credit Card',
    '3022.icon': '/classpath/assets/images/icons/platinum-rewards-visa-icon.svg',
    '3022.description': 'Credit card with an amazing low rate, built-in rewards, and no-fee balance transfers.',
    '3022.features.count': 4,
    '3022.features.1': 'Minimum payment is 2% of balance or $25.00, whichever is greater',
    '3022.features.2': 'One low interest rate for everyone',
    '3022.features.3': 'Earn <href>https://www.rcu.org/uchoose-rewards-disclosures || uChoose Rewards®</href> for every dollar spent',
    '3022.features.4': 'No-fee <href>https://www.rcu.org/platinum-rewards-visa-balance-transfer-disclosures || balance transfers</href> at any time',
    '3022.url': 'https://www.rcu.org/loans-credit/credit/platinum-credit-card',
    '3022.actionType': '3',
    '3022.actionType.url': 'https://www.loanliner.com/LoanRequest/CLPPresenter/GettingStarted.aspx?CUID=04809906&LoanFormId=7380695910005124928&ChannelId=3987423704049170222&LocationId=6138423703014152319&IsFramed=F',
    '3022.actionType.buttonText': 'Apply Now',
    '3022.disclosures.count': 0,

    '3023.name': 'Personal Line of Credit',
    '3023.icon': '/classpath/assets/images/icons/personal-line-credit-icon.svg',
    '3023.description': 'An unsecured line of credit that lets you borrow and repay as needed. The minimum credit line is $2,000, but you can borrow and repay just the amount you need.',
    '3023.features.count': 5,
    '3023.features.1': 'Minimum payment is 3% of balance or $20.00, whichever is greater',
    '3023.features.2': 'No minimum withdrawal lets you use only needed funds',
    '3023.features.3': 'Easily access funds via online or mobile banking, at an office, or at an ATM',
    '3023.features.4': 'No collateral needed',
    '3023.features.5': '$2,000 minimum credit line',
    '3023.url': 'https://www.rcu.org/loans-credit/credit/line-of-credit',
    '3023.actionType': '3',
    '3023.actionType.url': 'https://www.loanliner.com/LoanRequest/Presenter/LoanList/04809906/1130?isframed=F&cuid=04809906&loanlistid=1130&channelid=NONE&locationid=NONE',
    '3023.actionType.buttonText': 'Apply Now',
    '3023.disclosures.count': 0,

    '3024.name': 'Minor Loan',
    '3024.icon': '/classpath/assets/images/icons/icon-loan.svg',
    '3024.description': 'A minor loan may be an option for a minor under age 18 to borrow funds. A parent or guardian co-signer is required.',
    '3024.features.count': 2,
    '3024.features.1': 'A minor wants to establish credit history',
    '3024.features.2': 'The minor has a parent or guardian co-signer ',
    '3024.url': '',
    '3024.actionType': '4',
    '3024.actionType.url': 'tel:',
    '3024.actionType.buttonText': 'Contact Royal',
    '3024.disclosures.count': 0,

    '3025.name': 'New Purchase Mortgage Loan',
    '3025.icon': '/classpath/assets/images/icons/icon-buy-home.svg',
    '3025.description': 'Flexible financing options for buying a home. Also used for buying second homes.',
    '3025.features.count': 3,
    '3025.features.1': 'Get a low rate on a loan for buying a home',
    '3025.features.2': 'Low loan origination and closing costs',
    '3025.features.3': 'Can be used for second homes, cabins, or vacation homes',
    '3025.url': 'https://www.rcu.org/loans-credit/home-mortgage-loans/home-mortgage',
    '3025.actionType': '3',
    '3025.actionType.url': 'https://www.rcu.org/loans-credit/home-mortgage-loans/mlo-mla',
    '3025.actionType.buttonText': 'Get Started',
    '3025.disclosures.count': 0,

    '3026.name': 'New Construction/Land Loan',
    '3026.icon': '/classpath/assets/images/icons/home-improvement-icon.svg',
    '3026.description': 'Get funds for building a home or purchasing land.',
    '3026.features.count': 3,
    '3026.features.1': 'Interest-only payments during construction period',
    '3026.features.2': 'Converts to traditional loan after construction is complete',
    '3026.features.3': 'Land loans available for vacant land or recreational land',
    '3026.url': 'https://www.rcu.org/loans-credit/home-mortgage-loans/new-construction-vacant-land-loan',
    '3026.actionType': '4',
    '3026.actionType.url': 'https://homeloans.rcu.org/apply.asp?siteId=9734FF87-7F65-4340-8DF4-803C79B292B8',
    '3026.actionType.buttonText': 'Contact Royal',
    '3026.disclosures.count': 0,

    '3027.name': 'Mortgage Refinance',
    '3027.icon': '/classpath/assets/images/icons/icon-home-refinance.svg',
    '3027.description': 'Refinance an existing mortgage to change your interest rate or payments.',
    '3027.features.count': 3,
    '3027.features.1': 'Refinance an existing mortgage to change your term, rate, or payment',
    '3027.features.2': 'Refinancing at a lower rate could save money each month',
    '3027.features.3': 'Low loan origination and closing costs',
    '3027.url': 'https://www.rcu.org/loans-credit/home-mortgage-loans/refinance-home',
    '3027.actionType': '3',
    '3027.actionType.url': 'https://www.rcu.org/loans-credit/home-mortgage-loans/mlo-mla',
    '3027.actionType.buttonText': 'Get Started',
    '3027.disclosures.count': 0,

    '3028.name': 'Investment Property',
    '3028.icon': '/classpath/assets/images/icons/buying-investment-property.svg',
    '3028.description': 'Rental property financing for buildings with up to 4 units.',
    '3028.features.count': 3,
    '3028.features.1': 'For landlords interested in purchasing rental properties',
    '3028.features.2': 'Finance properties with up to 4 units',
    '3028.features.3': 'Not for commercial or business properties',
    '3028.url': 'https://www.rcu.org/loans-credit/home-mortgage-loans/investment-property',
    '3028.actionType': '4',
    '3028.actionType.url': 'https://www.rcu.org/loans-credit/home-mortgage-loans/investment-property ',
    '3028.actionType.buttonText': 'Contact Royal',
    '3028.disclosures.count': 0,

    '3029.name': 'Home Equity Line of Credit',
    '3029.icon': '/classpath/assets/images/icons/home-equity-loan-icon.svg',
    '3029.description': 'Borrow against the equity in your home for home improvements, repairs, and much more. The minimum credit line is $10,000, but you can borrow and repay just the amount you need.',
    '3029.features.count': 4,
    '3029.features.1': 'Borrow funds based on the equity you have in your home',
    '3029.features.2': 'Line of credit allows borrowing only the funds you need',
    '3029.features.3': 'May make interest-only payments during the draw period',
    '3029.features.4': 'Can use funds for almost any purpose, including remodeling or repairs',
    '3029.url': 'https://www.rcu.org/loans-credit/home-mortgage-loans/home-equity-line-of-credit',
    '3029.actionType': '3',
    '3029.actionType.url': 'https://www.rcu.org/loans-credit/home-mortgage-loans/mls',
    '3029.actionType.buttonText': 'Get Started',
    '3029.disclosures.count': 0,

    '3030.name': 'Contact Our Loan Team',
    '3030.icon': '/classpath/assets/images/icons/mortgage-team-icon.svg',
    '3030.description': 'Contact our team of loan experts for more help finding the right option for you.',
    '3030.features.count': 0,
    '3030.url': 'https://www.rcu.org/loans-credit/home-mortgage-loans/',
    '3030.actionType': '4',
    '3030.actionType.url': 'tel:',
    '3030.actionType.buttonText': 'Contact Royal',
    '3030.disclosures.count': 0,

    '3031.name': 'Contact Us',
    '3031.icon': '/classpath/assets/images/icons/icon-contact.svg',
    '3031.description': `We're here to help! Visit any office, email <href>mailto: member_services@rcu.org || member_services@rcu.org</href>, or call 800-341-9911 for more help finding the right option for you.`,
    '3031.features.count': 0,
    '3031.url': 'https://www.rcu.org/contact',
    '3031.actionType': '5',
    '3031.actionType.url': 'tel:',
    '3031.actionType.buttonText': 'Contact Royal',
    '3031.disclosures.count': 0,

    '3032.name': 'Enrich Financial Education',
    '3032.icon': '/classpath/assets/images/icons/enrich.svg',
    '3032.description': "We believe that everyone deserves access to resources to help them reach their financial goals and make informed financial decisions. That's why Royal's Enrich online learning platform is available to anyone!",
    '3032.features.count': 3,
    '3032.features.1': 'Access free personalized financial education tools, quizzes, articles, courses, and more',
    '3032.features.2': 'Learn about a variety of topics at your own pace with bite-sized lessons',
    '3032.features.3': 'Take a financial goals assessment and receive a personalized action plan',
    '3032.url': 'https://rcu.enrich.org/',
    '3032.actionType': '6',
    '3032.actionType.url': 'https://rcu.enrich.org/',
    '3032.actionType.buttonText': 'Get Started Today',
    '3032.disclosures.count': 0,

    '3033.name': 'Financial Wellness Review',
    '3033.icon': '/classpath/assets/images/icons/financial-wellness.svg',
    '3033.description': 'Royal is here to be your trusted advisor. Anyone is welcome to schedule a free one-on-one consultation in person with a Royal team member at their nearest Royal office.',
    '3033.features.count': 3,
    '3033.features.1': 'Get free in-person financial advice and recommendations',
    '3033.features.2': 'Review your current financial situation',
    '3033.features.3': 'Discuss strategies to reach your future goals',
    '3033.url': 'https://www.rcu.org/education-resources/financial-education/wellness-learning/free-financial-review',
    '3033.actionType.url': 'https://www04.timetrade.com/app/royalcu/workflows/WFroyalcu001/schedule?appointmentTypeGroupId=personal_banking&appointmentTypeId=sp_financial_goals',
    '3033.actionType.url.test': 'https://ui-stage.timetradesystems.com/app/royalcu/workflows/WFroyalcu001/schedule?appointmentTypeGroupId=personal_banking&appointmentTypeId=sp_financial_goals',
    '3033.actionType.buttonText': 'Schedule An Appointment',

    '10001.name': 'Save & Spend Duo',
    '10001.icon': '/classpath/assets/images/icons/icon-checking-save-spend.svg',
    '10001.description': 'Members who want a higher savings rate and frequently use digital banking and their debit card get more perks with this bundled checking and savings account. If the requirements below aren’t a good fit for you, you can still select separate checking and savings accounts.',
    '10001.features.count': 3,
    '10001.features.1': 'Duo Checking with Debit Roundup¹ for automatic savings with every purchase',
    '10001.features.2': 'Duo Savings earns a higher rate on the first $10,000',
    '10001.features.3': 'No monthly fee when you make 20 debit purchases each month and use online or mobile banking²',
    '10001.url': 'https://www.rcu.org/checking-savings/checking-accounts/save-spend',
    '10001.actionType': '1',
    '10001.actionType.buttonText': 'Open Account',
    '10001.actionType.url.count': 4,
    '10001.actionType.url.1': 'https://app.consumer.meridianlink.com/xa/xpressApp.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSMHgSJcNLeGXLfdNSEtvS6wyW3KPxZ5_asv5lOOwZWOE',
    '10001.actionType.url.2': 'https://app.consumer.meridianlink.com/xa/xpressApp.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSMHgSJcNLeGXLfdNSEtvS6wDKqSFS4eX1RSvHIGiqUeY',
    '10001.actionType.url.3': 'https://app.consumer.meridianlink.com/apply.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSn8o3dzOzOzEoJu1M9g82m4T_I9H1WFbOsxXSVHaU5-w',
    '10001.actionType.url.4': 'https://app.consumer.meridianlink.com/apply.aspx?enc=Kw21Wblm1yxpjJabdoZaD8AS8GPRyYTEuo7BbB5BfuPfFKOxrYImUvQsnZOxv5NSn8o3dzOzOzEoJu1M9g82m08U7i6BCHxpn9b3nRLaM6Q',
    '10001.disclosures.count': 4,
    '10001.disclosures.1': 'Insured by NCUA.',
    '10001.disclosures.2': 'No minimum balance required to open Duo accounts or earn APY.',
    '10001.disclosures.3': '¹Debit Roundup rounds up physical debit card, digital wallet, or debit card number purchases to the next whole dollar and deposits the roundup amount to Duo Savings daily.',
    '10001.disclosures.4': '²Fees could reduce balance and earnings. Duo Checking will incur a $5 monthly fee unless 20 debit purchases are posted to the account that calendar month and at least one account holder has logged in to online or mobile banking within the past 90 days.',
}